import Marquee from "react-fast-marquee";

const ITEMS = ["Learning Lights", "Let's Ignite Young Minds", "Literacy Improves Lives", "Transforming Education"];

export const MarqueeBand = () => (
  <section className="py-14 border-y border-forest/15 overflow-hidden" data-testid="marquee-band" aria-hidden="true">
    <Marquee speed={35} gradient={false} pauseOnHover={false}>
      {ITEMS.map((t, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif italic font-bold text-6xl lg:text-8xl outline-text mx-8 whitespace-nowrap">{t}</span>
          <span className="w-3 h-3 rounded-full bg-terra inline-block" />
        </span>
      ))}
    </Marquee>
  </section>
);
